import { personInfoFrag } from '../../../../../utils/type/person.common-type';
import { addressInfoFrag } from '../../../../../utils/type/address.common-type';

const serviceMedicalProcedureFrag = `
    code
    customCode
    customName
    color
    procedure {
        code
        description
    }
`;

export const getWorksFrag = `
    id
    dateFrom
    dateTo
    folderId
    serviceId
    person {
        ${personInfoFrag}
        insurances {
            insuranceAbbr
        }
        addresses {
            address {
                ${addressInfoFrag}
            }
        }
    }
    users {
        id
        name
        surname
        titleBeforeName
        titleAfterName
        email
        image
        sex
    }
    workType
    signed
    signedAt
    workData {
        ... on WorkDataVisitObject {
            distanceFrom
            distanceTo
            addressFrom {
                ${addressInfoFrag}
            }
            addressTo {
                ${addressInfoFrag}
            }
            locked
        }
    }
    files {
        fileId
        name
        path
    }
    performedProcedures {
        applications
        code
        serviceMedicalProcedure {
            ${serviceMedicalProcedureFrag}
        }
        voucherPrescribedMedicalProcedure {
            voucher {
                sequenceNumber
            }
            serviceMedicalProcedure {
                ${serviceMedicalProcedureFrag}
            }
        }
    }
    folderFormData {
        folderForm {
            form {
                uniqueIdentifier
            }
        }
    }
`;
